import fetch from '../../utils/fetch'
import { btoa, encrypt, decrypt } from '../../utils/common/common'
import { PERMISSION } from '../../constants/common'
import AuthenApi from '../Auth/Auth';
export function login(email, password, callback) {
    fetch(`${process.env.REACT_APP_API}/users/auth`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${btoa(`${email}:${password}`)}`,
        },
    }).then(callback)
}

export function logout() {
    localStorage.removeItem('qc_sid')
    localStorage.removeItem('qc_email')
    localStorage.removeItem('qc_uid')
    localStorage.removeItem('sid')
}

export function setSession(data) {
    for (const k in data) {
        if (Object.hasOwnProperty.call(data, k)) {
            localStorage.setItem(k, encrypt(data[k]))
        }
    }
}

export function getSession(sessionKey) {
    return decrypt(localStorage.getItem(sessionKey) || '')
}

export function setLocalStorageAsync(key, value) {
    return Promise.resolve().then(function() {
        localStorage.setItem(key, value);
    })
}

export function getLocalStorageAsync(key) {
    return Promise.resolve().then(function() {
        return localStorage.getItem(key);
    })
}

export async function setSessionAsync(key, value) {
    const hashValue = await encrypt(value);
    return await setLocalStorageAsync(key, hashValue);
}

export async function isAuthenticated() {
    const sid = getSession('sid')
    const token = new URLSearchParams(window.location.search).get('sid') || getSession('sid')
    if (!sid && !token) return false
    return await verifySession(token)
}

export async function verifyToken(accessToken) {
    if (!accessToken) return false
    const verifyRes = await fetch(`${process.env.REACT_APP_API}/sessions/verify-token`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })
    return verifyRes.status === 200
}

export async function verifySession(sessionID) {
    if (!sessionID) return false
    return fetch(`/identity/sessions/verify`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${sessionID}`
        }
    }).then(async (res) => {
        await setSessionAsync('sid', sessionID);
        if (PERMISSION.LOGIN.includes(res.body?.result?.role)) {
            localStorage.setItem('role', res.body?.result?.role);
            return true;
        };
        if (res.status === 498) {
            return false;
        }
        await AuthenApi.logoutUser();
        alert("Something went wrong!")
        return false;
    }).catch(async (error) => {
        alert("Something went wrong!")
        return false;
    })
}

export async function getProfile() {
    const accessToken = getSession('sid')
    if (!accessToken) return false
    return fetch(`${process.env.REACT_APP_API}/identity/users/profile`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    }).then(res => {
        if (res.status === 200) {
            return res.body.result;
        }
    })
}

export default {
    login,
    logout,
    setSession,
    getSession,
    isAuthenticated,
    verifyToken,
    verifySession,
    getProfile
}